<template>
    <ion-card>
        <ion-card-header>
            <ion-card-title>{{ $t('ncrypt.vault.add_title') }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <div v-if="limitReached">
                <ion-item color="danger"
                          style="width: 100%;">
                    {{ $t('ncrypt.vault.limit_reached') }}
                </ion-item>

                <ion-button @click="$emit('upgrade')"
                            size="default"
                            shape="round"
                            style="margin: 10px auto;">
                    {{ $t('ncrypt.vault.limit_reached_upgrade_account') }}
                </ion-button>
            </div>
            <ion-item lines="none" v-else>
                <file-uploader
                        ref="fileUploader"
                        bucket="ncrypt-vault"
                        :dropzoneOptions="dropzoneOptions"
                        :addFileText="$t('ncrypt.vault.add_file_text')"
                />
            </ion-item>

            <ion-item lines="none">
                <ion-button :disabled="submitting || limitReached"
                            expand="block"
                            size="default"
                            shape="round"
                            style="margin: 0 auto;"
                            @click="processQueue">
                    {{ $t('ncrypt.vault.add_button') }}
                </ion-button>
            </ion-item>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import FileUploader from "../FileUploader";
    import {Notifier} from "../../services/Notifier";

    export default {
        name: "VaultAddFile",
        components: {FileUploader},
        props: {
            limitReached: {type: Boolean},
        },
        data() {
            return {
                submitting: false,
            }
        },
        computed: {
            dropzoneOptions() {
                return {
                    maxFiles: 1,
                    maxFilesize: this.maxFileSize,
                }
            },
            maxFileSize() {
                return this.$store.getters.maxAttachmentSize;
            },
        },
        methods: {
            isValid() {
                return this.$refs.fileUploader.isValid();
            },
            async processQueue() {
                if (!this.$refs.fileUploader.dropzone.getQueuedFiles().length) {
                    await Notifier.showAlert({
                        message: this.$t('ncrypt.errors.vault_select_file_first_alert'),
                    });
                    return;
                }

                this.submitting = true;

                const finishedUrl = `${this.$store.getters.api_url}/vault/uploaded`;

                await this.$refs.fileUploader.processQueue(finishedUrl, []);

                this.submitting = false;

                await Notifier.showToast({
                    message: this.$t('ncrypt.notifications.vault_file_was_added_toast'),
                });

                this.$emit('completed');
            },
        },
    }
</script>

<style lang="scss">
    #app {
        .dropzone.dz-started .dz-message {
            display: none;
        }
    }
</style>
